export default __webpack_public_path__ + "media/src/features/home-claim/assets/claim-your-home-icon/claim-your-home-icon-ab8d0712260f44c50809b0456be5bfa0.png";